<template>
    <div>
        <el-select v-model="value" filterable :placeholder="$t('zhiji.common.selectBusi')" @change="changeHandler">
            <el-option v-for="item in businessItems" :key="item.value" :label="item.label" :value="item.value"></el-option>
            <el-option value="new" label="$t('zhiji.common.newBusiness')" v-if="hasAddPermit">
                <div @click.stop="newBusiness"><i class="el-icon-plus"></i>{{ $t("zhiji.common.newBusiness") }}</div>
            </el-option>
        </el-select>
        <AddDialog :show="showAdd" @close="hideDialog" @submit="addBusiness" />
    </div>
</template>

<script>
import checkAuth, { changeBusiness } from "@/lib/auth";
import AddDialog from "./AddDialog";
import { addBusiness } from "./service";

// 业务选择组件
export default {
    name: "BusinessSelect",
    data() {
        return {
            value: this.initValue(),
            showAdd: false
        };
    },
    components: {
        AddDialog
    },
    computed: {
        businessItems() {
            return (this.getModuleProp("business_list") || []).map(bItem => ({
                label: bItem.business_name,
                value: bItem.business_id
            }));
        },
        curBusinessId() {
            return this.getModuleProp("businessId");
        },
        hasAddPermit() {
            return checkAuth("business.add");
        }
    },
    watch: {
        curBusinessId() {
            this.value = this.curBusinessId;
        }
    },
    methods: {
        getModuleProp(propName) {
            return this.$store.state.auth[propName];
        },
        changeHandler() {
            if (this.value != "new") {
                changeBusiness(this.value);
            }
        },
        initValue() {
            return this.getModuleProp("businessId");
        },
        newBusiness() {
            this.showAdd = true;
        },
        hideDialog() {
            this.showAdd = false;
        },
        async addBusiness(name) {
            const businessId = await addBusiness(name);
            this.hideDialog();
            changeBusiness(businessId, true);
            window.location.href = "/businesssetting";
        }
    }
};
</script>

<style></style>
